import { VehicleTypeEnum } from './enums';
import { CountryEnum } from '@/models/Enums';

export interface FamilySegment {
  idfamily: number;
  familyname: string;
  vehicletypes: number[];
  familybrandname: string;
}

export interface FamilySegments {
  idSegment: number;
  segmentName: string;
  idBrand: number;
}

export interface Brand {
  id: number;
  name: string;
}

export interface Model {
  id: number;
  name: string;
  brand: Brand;
  familyversion: FamilyVersion;
  idorigin: number;
  idvehicletypeoriginrange: number | null;
  vehicletypes: VehicleType[];
  vehicletypeorigin: VehicleType;
  country: CountryEnum;
  marketvalue?: number;
  marketvaluereference?: string;
}

export interface FamilyVersion {
  id: number;
  name: string;
  family?: Family;
}

export interface Family {
  id: number;
  name: string;
  tags: number[];
  tagsname: string;
  familygroup?: FamilyGroup;
  idsocialclass?: number | null;
}

export interface Tag {
  id: number;
  name: string;
}

export interface VehicleType {
  id: number;
  name: string;
}

export interface FamilyGroup {
  id: number;
  name: string;
}

export interface ComponentItem {
  id: number;
  name: string;
  market?: IMarket;
}

export interface SegmentModel {
  brandname: string;
  segmentname: string;
}

export interface Segment {
  id: number;
  name: string;
  isapplied: boolean;
}

export class VehicleTypeOriginRange {
  public static GetVehicleTypeName(idvehicletypeoriginrange: number | null, vehicleTypeOrigins: VehicleTypeOriginRange[]): string {
    const result = vehicleTypeOrigins
      .filter((vto: VehicleTypeOriginRange) => idvehicletypeoriginrange === vto.idvehicletypeoriginrange)
      .map((vto: VehicleTypeOriginRange) => vto.name);

    return result.length ? result[0] : '-';
  }

  public idvehicletypeoriginrange: number;
  public name: string;
}

export const tabs = { list: 'list', form: 'form' };

export const vehicleTypes: any = {
  [VehicleTypeEnum.Car]: {
    name: 'Automóvel e Comercial Leve',
    icon: 'mdi-car-hatchback',
  },
  [VehicleTypeEnum.Motocycle]: {
    name: 'Motocicleta',
    icon: 'mdi-motorbike',
  },
  [VehicleTypeEnum.Truck]: {
    name: 'Caminhão e Ônibus',
    icon: 'mdi-truck',
  },
  [VehicleTypeEnum.FarmMachine]: {
    name: 'Máquina Agrícola',
    icon: 'mdi-tractor-variant',
  },
  [VehicleTypeEnum.RoadImplement]: {
    name: 'Implemento Rodoviário',
    icon: 'mdi-truck-trailer',
  },
};

export interface IMarket {
  money: string;
  date: string;
  getDateISO(): string;
  getDateFormatted(): string;
  getMoneyNumber(): number;
  getMoneyFormatted(): string;
  validate(): [boolean, string];
}
